import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Product visibility is separate from legacy account entitlements.
// Keep upstream features available in the codebase for future use.
export const PRODUCT_CONFIG = {
  hiddenFeatures: [
    FEATURE_FLAGS.HELP_CENTER,
    FEATURE_FLAGS.SLA,
    FEATURE_FLAGS.SAML,
    FEATURE_FLAGS.CUSTOM_ROLES,
    FEATURE_FLAGS.AUDIT_LOGS,
    FEATURE_FLAGS.CAPTAIN,
    FEATURE_FLAGS.CAPTAIN_V2,
    FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
    FEATURE_FLAGS.CAPTAIN_TASKS,
    FEATURE_FLAGS.CAPTAIN_DOCUMENT_AUTO_SYNC,
  ],
  primaryInboxChannels: ['whatsapp', 'instagram', 'facebook', 'telegram'],
  hiddenProfileMenuItems: ['documentation', 'changelog'],
};

// Routes and menu items without a feature flag must never count as hidden.
export const isHiddenFeature = featureFlag =>
  Boolean(featureFlag) && PRODUCT_CONFIG.hiddenFeatures.includes(featureFlag);
